import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import ListIcon from '@material-ui/icons/List';

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'flex',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
}));

export default function TopNavigation({ volunteerFullName }) {
  const classes = useStyles();
  const isVolunteersListPage = window.location.pathname === '/volunteers';

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {!isVolunteersListPage && (
        <Link to="/volunteers">
          <Typography color="textPrimary" className={classes.link}>
            <ListIcon className={classes.icon} />
            Анкеты волонтёров
          </Typography>
        </Link>
      )}

      {volunteerFullName && (
        <Typography color="textPrimary" className={classes.link}>
          <PermIdentityIcon className={classes.icon} />
          {volunteerFullName}
        </Typography>
      )}
    </Breadcrumbs>
  );
}
